(function () {
  var CUSTOM_BUTTON_SELECTOR = '[role="button"]:not(button):not(input):not(a[href])';

  function init(root) {
    if (!root || root.dataset.lunastraDiyReady === "true") return;
    root.dataset.lunastraDiyReady = "true";
    root.querySelectorAll(".match-fields select, .match-fields input, .match-location-fields input").forEach(function (field) {
      field.addEventListener("change", function () {
        field.setAttribute("data-lunastra-touched", "true");
      });
    });
    root.querySelectorAll(CUSTOM_BUTTON_SELECTOR).forEach(function (control) {
      if (!control.hasAttribute("tabindex")) control.setAttribute("tabindex", "0");
    });
    root.addEventListener("keydown", function (event) {
      var control = event.target.closest(CUSTOM_BUTTON_SELECTOR);
      if (!control || !root.contains(control)) return;
      if ((event.key !== "Enter" && event.key !== " ") || event.repeat) return;
      event.preventDefault();
      if (control.id === "rotate-control") {
        root.dispatchEvent(new CustomEvent("lunastra:diy-rotate", { detail: { delta: 15 } }));
        return;
      }
      control.click();
    });
  }

  window.LunastraDiy = window.LunastraDiy || { init: init };
  function boot() {
    document.querySelectorAll(".lunastra-diy-v3").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
